import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { publicPost } from "../admin/api";
import PrivacyNotice from "../components/brand/PrivacyNotice";

const APPEAL_TYPES = ["manual", "mcp_server", "npm_package", "pypi_package", "x402_endpoint"];

export default function Appeal() {
  // "Request a correction" on a server profile links here with the item prefilled.
  const [sp] = useSearchParams();
  const correction = sp.get("correction") === "1";
  const [form, setForm] = useState({
    contact_email: "", item_type: APPEAL_TYPES.includes(sp.get("item_type")) ? sp.get("item_type") : "manual",
    item_identifier: (sp.get("item_identifier") || "").slice(0, 512),
    message: correction ? "Correction requested for the public profile: " : "", honeypot_hp: "",
  });
  const [status, setStatus] = useState(null);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setStatus(null);
    try {
      const data = await publicPost("/public/appeals", form);
      setStatus(data);
    } catch (ex) {
      setErr(ex.message);
    }
  };
  return (
    <section data-testid="appeal-page" className="space-y-6">
      <h1 className="hs-display text-3xl md:text-4xl">{correction ? "Request a correction" : "File an appeal"}</h1>
      <p className="text-muted hs-prose">
        If an item attributed to you has been flagged in error, file an appeal. We review
        every submission with a human in the loop. Upheld appeals re-queue the item for
        human reclassification and never auto-change the public tier.
      </p>
      <form onSubmit={submit} data-testid="appeal-form" className="hs-card max-w-2xl space-y-4">
        <div>
          <label className="hs-label" htmlFor="appeal-email">Contact email</label>
          <input id="appeal-email" data-testid="appeal-email" required type="email" className="hs-input"
                 value={form.contact_email} onChange={e => setForm({ ...form, contact_email: e.target.value })} />
        </div>
        <div>
          <label className="hs-label" htmlFor="appeal-type">Item type</label>
          <select id="appeal-type" data-testid="appeal-type" className="hs-input"
                  value={form.item_type} onChange={e => setForm({ ...form, item_type: e.target.value })}>
            {APPEAL_TYPES.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className="hs-label" htmlFor="appeal-identifier">Item identifier</label>
          <input id="appeal-identifier" data-testid="appeal-identifier" required className="hs-input hs-mono"
                 value={form.item_identifier} onChange={e => setForm({ ...form, item_identifier: e.target.value })} />
        </div>
        <div>
          <label className="hs-label" htmlFor="appeal-message">Message</label>
          <textarea id="appeal-message" data-testid="appeal-message" required rows={5} className="hs-input"
                    value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} />
        </div>
        {/* Honeypot: hidden from humans via positioning, picked up by naive bots. */}
        <input data-testid="appeal-honeypot" tabIndex={-1} autoComplete="off" aria-hidden="true"
               style={{ position: "absolute", left: "-9999px", width: 1, height: 1 }}
               value={form.honeypot_hp} onChange={e => setForm({ ...form, honeypot_hp: e.target.value })} />
        <button data-testid="appeal-submit" type="submit" className="hs-btn hs-btn-primary">Submit appeal</button>
        <PrivacyNotice />
        {err && <div data-testid="appeal-error" role="alert" className="hs-text-danger">{err}</div>}
        {status && (
          <div data-testid="appeal-success" role="status">
            <span className="hs-badge hs-badge-safe mr-2">Received</span>
            id <code className="hs-mono">{status.id}</code> · status <code className="hs-mono">{status.status}</code>
          </div>
        )}
      </form>
    </section>
  );
}
